import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import BezpieczenstwoPage from "@/pages/article/BezpieczenstwoPage";
import PoczatkujacyPage from "@/pages/article/PoczatkujacyPage";
import FindsPage from "@/pages/article/FindsPage";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artykul/kakobuy-spreadsheet-polska-poradnik",
    element: <ArticlePage />,
  },
  {
    path: "/artykul/czy-kakobuy-jest-bezpieczny",
    element: <BezpieczenstwoPage />,
  },
  {
    path: "/artykul/kakobuy-dla-poczatkujacych",
    element: <PoczatkujacyPage />,
  },
  {
    path: "/artykul/najlepsze-kakobuy-finds",
    element: <FindsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;